import { Plan, PlanCategory } from '@/shared/types/Billing';

export const excludePlanByCategory = (plans: Plan[], excludedCategories: Set<PlanCategory>) => {
  return plans.filter((plan) => !excludedCategories.has(plan.category));
};
